import React, { useContext } from "react";


function CenteredPageContainer(props) {
    return (
        <div className={`centered-page-container ${props.noPadding ? "no-padding" : ""} ${props.startAtTopMobile ? "start-at-top-mobile" : ""}`}>
            {props.children}
        </div>
    )
}

export default CenteredPageContainer;